import { Box, Flex, Img, Text, FlexProps } from "@chakra-ui/react";
import React from "react";
import colors from "../../utils/colors";

export interface IProps extends FlexProps {
  img: string;
  title: string;
  value: string | number;
}

const InfoCard = ({ img, title, value, ...rest }: IProps) => {
  return (
    <Flex
      p={4}
      bg={colors.white}
      borderRadius="md"
      alignItems="center"
      gap={3}
      boxShadow="sm"
      {...rest}
    >
      <Img src={img} alt={title} boxSize="40px" />
      <Box>
        <Text fontSize="sm" color="gray.600">
          {title}
        </Text>
        <Text fontSize="xl" fontWeight="bold" color={colors.dark}>
          {value}
        </Text>
      </Box>
    </Flex>
  );
};

export default InfoCard;
